import { useTranslation } from 'react-i18next'
import i18n from 'i18next'
import useI18n from '@/shared/hooks/usei18n'
import { SUPPORTED_LANGUAGES } from '@/shared/config/languages'
import { useUpdateLanguage } from '@/shared/hooks/api/user'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

export function LanguageForm() {
  const { t } = useTranslation('common')
  const { currentLanguage } = useI18n()
  const { mutateAsync: updateLanguage, isPending: isUpdatingLanguage } =
    useUpdateLanguage()

  const currentOption =
    SUPPORTED_LANGUAGES.find((lang) => lang.value === currentLanguage) ??
    SUPPORTED_LANGUAGES[0]

  const handleChangeLanguage = async (value: string) => {
    await updateLanguage(value)
    await i18n.changeLanguage(value)
  }

  return (
    <div className='space-y-4'>
      <div className='space-y-2'>
        <Label>{t('settings.interfaceLanguageLabel')}</Label>
        <Select
          value={currentLanguage}
          onValueChange={(value) => {
            if (value) {
              void handleChangeLanguage(value)
            }
          }}
          disabled={isUpdatingLanguage}
          items={SUPPORTED_LANGUAGES.map((lang) => ({
            value: lang.value,
            label: lang.label,
          }))}
        >
          <SelectTrigger className='w-[240px]'>
            <SelectValue>
              <span className='flex items-center gap-2'>
                <span>{currentOption.flag}</span>
                <span>{currentOption.label}</span>
              </span>
            </SelectValue>
          </SelectTrigger>
          <SelectContent>
            {SUPPORTED_LANGUAGES.map((lang) => (
              <SelectItem key={lang.value} value={lang.value}>
                <span className='flex items-center gap-2'>
                  <span>{lang.flag}</span>
                  <span>{lang.label}</span>
                </span>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <p className='text-sm text-muted-foreground'>
          {t('settings.languageDescription')}
        </p>
      </div>
    </div>
  )
}
